module.exports = __webpack_public_path__ + "static/media/federation.da9934b7.svg";